import React, { Component } from "react";
import styled from "styled-components";
import { Icon } from "semantic-ui-react";

const Wrapper = styled.section`
  background: white;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const Title = styled.label`
  font-size: 1.5em;
  text-align: center;
  color: #34495e;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-variant: normal;
  font-weight: bold;
  line-height: 35px;
  padding-top: 10px;
`;
const SubTitle = styled.label`
  font-size: 1em;
  text-align: center;
  color: #eb4b2e;
  font-weight: bold;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
`;

const Description = styled.label`
  padding-top: 10px;
  font-size: 1.3em;
  text-align: center;
  color: #34495e;
  font-weight: 400;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
`;

class PromoCard extends Component {
  render() {
    return (
      <Wrapper>
        <Icon
          style={{ color: "#eb4b2e", fontSize: "70px" }}
          name={this.props.icon}
        />
        <Title>{this.props.name.toUpperCase()}</Title>
        <Description>{this.props.description}</Description>
      </Wrapper>
    );
  }
}

const styles = {
  doubleFont: {
    fontSize: "1.5rem"
  }
};

export default PromoCard;



// WEBPACK FOOTER //
// ./src/components/PromoCard.js